import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useMemo } from 'react';

import { Badge } from '../../core/Badge';
import { IconButton } from '../../core/IconButton';
import { useValidationTranslator } from '../../datamodel/hooks/useValidationTranslator';
import HoverPopover from '../hoverPopover';
import { TooltipList } from './actionTooltipList';

const uniqStrings = (values: string[] | undefined): string[] => Array.from(new Set(values || []));

export const ValidationsPopover = ({ item }: { item: any }) => {
    const { translateValidationLabel } = useValidationTranslator();

    const items = useMemo(() => {
        const translateKey = (key: string) => {
            const index = key.indexOf(':');
            const attr = index >= 0 ? key.slice(0, index) : undefined;
            const val = index >= 0 ? key.slice(index + 1) : key;
            return translateValidationLabel(val, attr);
        };

        const errors = uniqStrings(item.validation__).map((key, index) => ({
            key: `error-${index}-${key}`,
            text: translateKey(key),
            severity: 'error' as const,
        }));
        const warnings = uniqStrings(item.validation_warnings__).map((key, index) => ({
            key: `warning-${index}-${key}`,
            text: translateKey(key),
            severity: 'warning' as const,
        }));

        return [...errors, ...warnings];
    }, [item.validation__, item.validation_warnings__, translateValidationLabel]);

    if (!items.length) return null;

    const trigger = (
        <div className="tw-relative">
            <IconButton variant="lighter-gray" icon={ExclamationTriangleIcon} size="lg" className='tw-py-[10px] tw-pr-[15px]'/>
            {item.validation__?.length > 0 &&
                <Badge variant="error" type='count' className='tw-absolute tw-top-1 tw-right-0'>
                    {item.validation__?.length}
                </Badge>}
            {item.validation_warnings__?.length > 0 &&
                <Badge variant="warning" type='count' className="tw-absolute tw-bottom-1 tw-right-0">
                    {item.validation_warnings__?.length}
                </Badge>}
        </div>
    );

    return <HoverPopover triggerContent={trigger}><TooltipList items={items} /></HoverPopover>;
};
